
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire83e5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire83e5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iOiPU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Animator = void 0;
var $db1b81f84458a82c$var$Animator = /** @class */ function() {
    function Animator(timelines) {
        this._pausedTime = undefined;
        this._lastTime = Date.now();
        this._startTime = Date.now();
        this._timelines = timelines;
        this._animationFrame = null;
    }
    Object.defineProperty(Animator.prototype, "isRunning", {
        get: function() {
            return Boolean(this._animationFrame);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Animator.prototype, "startTime", {
        get: function() {
            return this._startTime;
        },
        set: function(startTime) {
            this._startTime = startTime;
        },
        enumerable: false,
        configurable: true
    });
    Animator.prototype.onTick = function(onTick) {
        this._onTick = onTick;
    };
    Animator.prototype.onStep = function(onStep) {
        this._onStep = onStep;
    };
    Animator.prototype.computeFrameAt = function(time) {
        var _a;
        var elapsedTime = time - this._startTime;
        var deltaTime = (time - this._lastTime) / 1000; // In sec
        this._lastTime = time;
        for(var _i = 0, _b = this._timelines; _i < _b.length; _i++){
            var timeline = _b[_i];
            var timelineTime = elapsedTime % timeline.totalDuration;
            var step = timeline.getCurrentStep(timelineTime);
            if (step) {
                var durationUntilStep = timeline.getDurationUntilStep(step);
                var stepTime = (timelineTime - durationUntilStep) / step.duration;
                /**
                 * Trigger the on start callback on the first frame of a step.
                 */ if (step !== timeline.lastStep || timeline.lastStepTime > stepTime) {
                    if ((_a = timeline.lastStep) === null || _a === void 0 ? void 0 : _a.onEnd) timeline.lastStep.onEnd();
                    if (step.onStart) step.onStart();
                    if (this._onStep) this._onStep(elapsedTime, step, deltaTime);
                }
                if (step.handler) step.handler(stepTime, deltaTime);
                if (this._onTick) this._onTick(elapsedTime, step, deltaTime);
                timeline.lastStepTime = stepTime;
                timeline.lastStep = step;
            } else this.stop();
        }
    };
    Animator.prototype.loop = function() {
        var _this = this;
        this._animationFrame = requestAnimationFrame(function() {
            _this.computeFrameAt(Date.now());
            _this.loop();
        });
    };
    Animator.prototype.start = function() {
        if (typeof this._pausedTime !== 'undefined') {
            var deltaTime = this._pausedTime - this._startTime;
            this._startTime = Date.now() - deltaTime;
        } else this._startTime = Date.now();
        this._lastTime = Date.now();
        this._pausedTime = undefined;
        this.loop();
    };
    Animator.prototype.stop = function() {
        if (this._animationFrame) cancelAnimationFrame(this._animationFrame);
        this._pausedTime = undefined;
        this._animationFrame = null;
    };
    Animator.prototype.pause = function() {
        if (this._animationFrame) cancelAnimationFrame(this._animationFrame);
        this._pausedTime = Date.now();
        this._animationFrame = null;
    };
    Animator.prototype.getDuration = function() {
        return Math.max.apply(Math, this._timelines.map(function(timeline) {
            return timeline.getDuration();
        }));
    };
    return Animator;
}();
module.exports.Animator = $db1b81f84458a82c$var$Animator;

});

parcelRegister("e8wtc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeline = void 0;
var $a4aaffe45160ff0e$var$Timeline = /** @class */ function() {
    function Timeline(steps) {
        this._steps = steps;
        this._lastStepTime = 0;
        this._lastStep = null;
    }
    Object.defineProperty(Timeline.prototype, "totalDuration", {
        get: function() {
            return this._steps.reduce(function(acc, step) {
                return acc += step.duration;
            }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Timeline.prototype, "lastStep", {
        get: function() {
            return this._lastStep;
        },
        set: function(lastStep) {
            this._lastStep = lastStep;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Timeline.prototype, "lastStepTime", {
        get: function() {
            return this._lastStepTime;
        },
        set: function(lastStepTime) {
            this._lastStepTime = lastStepTime;
        },
        enumerable: false,
        configurable: true
    });
    Timeline.prototype.getCurrentStep = function(time) {
        var currentTime = 0;
        for(var _i = 0, _a = this._steps; _i < _a.length; _i++){
            var step = _a[_i];
            if (time <= currentTime + step.duration) return step;
            currentTime += step.duration;
        }
        return this._steps[this._steps.length - 1];
    };
    Timeline.prototype.getDurationUntilStep = function(step) {
        var stepIndex = this._steps.indexOf(step);
        var beforeSteps = this._steps.slice(0, stepIndex);
        return beforeSteps.reduce(function(acc, it) {
            return acc += it.duration;
        }, 0);
    };
    Timeline.prototype.getDuration = function() {
        return this._steps.reduce(function(duration, step) {
            duration += step.duration;
            return duration;
        }, 0);
    };
    return Timeline;
}();
module.exports.Timeline = $a4aaffe45160ff0e$var$Timeline;

});

parcelRegister("9JUeZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Step = void 0;
var $7173f146cc90c1c9$var$Step = /** @class */ function() {
    function Step() {
        this.duration = 0;
    }
    return Step;
}();
module.exports.Step = $7173f146cc90c1c9$var$Step;

});

var $37a01bc1518e38b9$exports = {};
"use strict";
var $37a01bc1518e38b9$var$__createBinding = $37a01bc1518e38b9$exports && $37a01bc1518e38b9$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $37a01bc1518e38b9$var$__exportStar = $37a01bc1518e38b9$exports && $37a01bc1518e38b9$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $37a01bc1518e38b9$var$__createBinding(exports1, m, p);
};
Object.defineProperty($37a01bc1518e38b9$exports, "__esModule", {
    value: true
});

$37a01bc1518e38b9$var$__exportStar((parcelRequire("iOiPU")), $37a01bc1518e38b9$exports);

$37a01bc1518e38b9$var$__exportStar((parcelRequire("e8wtc")), $37a01bc1518e38b9$exports);

$37a01bc1518e38b9$var$__exportStar((parcelRequire("9JUeZ")), $37a01bc1518e38b9$exports);


const $df5bef30413a053b$export$1860c7b6fa9bf376 = (element, style)=>{
    for (const [key, value] of Object.entries(style))element.style[key] = value;
};
const $df5bef30413a053b$export$2e015b6955893291 = (array)=>{
    return array[Math.floor(Math.random() * array.length)];
};
const $df5bef30413a053b$export$a9fc1fd4992bc427 = (group, fonts)=>{
    return fonts.filter((font)=>font.group === group);
};
const $df5bef30413a053b$export$66ccd79b5d09c124 = (fonts)=>{
    return fonts.map((font)=>font.weight);
};



class $1715526d97494fcc$export$d7a960146e1a269e {
    constructor(element){
        this.element = element;
    }
    reset() {
        // Reset visible span to empty
        this.visibleSpan.innerText = "";
    }
    setText(text) {
        this.text = text;
        this.element.innerHTML = "";
        // Ensure parent has relative positioning
        (0, $df5bef30413a053b$export$1860c7b6fa9bf376)(this.element, {
            position: "relative"
        });
        // Create hidden span with ALL text (reserves space for entire word)
        this.hiddenSpan = document.createElement("span");
        this.hiddenSpan.classList.add("hidden");
        this.hiddenSpan.innerText = text;
        (0, $df5bef30413a053b$export$1860c7b6fa9bf376)(this.hiddenSpan, {
            opacity: "0"
        });
        this.element.appendChild(this.hiddenSpan);
        // Create visible span (overlays hidden, shows revealed letters)
        this.visibleSpan = document.createElement("span");
        this.visibleSpan.classList.add("visible");
        (0, $df5bef30413a053b$export$1860c7b6fa9bf376)(this.visibleSpan, {
            position: "absolute",
            left: "0",
            top: "0"
        });
        this.element.appendChild(this.visibleSpan);
    }
    render(progress) {
        const totalLetters = this.text.length;
        const visibleCount = Math.floor(progress * (totalLetters + 1));
        // Show revealed letters in the visible span
        this.visibleSpan.innerText = this.text.slice(0, visibleCount);
    }
}


const $d13e1ce204297f81$export$f45fbea8fe20ca8a = [
    {
        name: "Theinhardt-Pan-Medium",
        type: "Medium",
        group: "Theinhardt-Pan",
        weight: 600
    },
    {
        name: "Theinhardt-Pan-Medium",
        type: "Medium",
        group: "Theinhardt-Pan",
        weight: 600
    },
    {
        name: "Theinhardt-Pan-Hairline",
        type: "Hairline",
        group: "Theinhardt-Pan",
        weight: 100
    },
    {
        name: "Theinhardt-Pan-Ultralight",
        type: "Ultralight",
        group: "Theinhardt-Pan",
        weight: 200
    },
    {
        name: "Theinhardt-Pan-Thin",
        type: "Thin",
        group: "Theinhardt-Pan",
        weight: 300
    },
    {
        name: "Theinhardt-Pan-Light",
        type: "Light",
        group: "Theinhardt-Pan",
        weight: 400
    },
    {
        name: "Theinhardt-Pan-Regular",
        type: "Regular",
        group: "Theinhardt-Pan",
        weight: 500
    },
    {
        name: "Theinhardt-Pan-Medium",
        type: "Medium",
        group: "Theinhardt-Pan",
        weight: 600
    },
    {
        name: "Theinhardt-Pan-Bold",
        type: "Bold",
        group: "Theinhardt-Pan",
        weight: 700
    },
    {
        name: "Theinhardt-Pan-Heavy",
        type: "Heavy",
        group: "Theinhardt-Pan",
        weight: 800
    },
    {
        name: "Theinhardt-Pan-Black",
        type: "Black",
        group: "Theinhardt-Pan",
        weight: 900
    }
];


var $b4e14b6b8da86996$var$Actions = /*#__PURE__*/ function(Actions) {
    Actions["Start"] = "start";
    Actions["Stop"] = "stop";
    Actions["Reset"] = "reset";
    return Actions;
}($b4e14b6b8da86996$var$Actions || {});
const $b4e14b6b8da86996$var$isMobile = ()=>{
    return window.innerWidth < 800;
};
const $b4e14b6b8da86996$var$getFitRatio = ()=>{
    return $b4e14b6b8da86996$var$isMobile() ? 1.9 : 2.22;
};
const $b4e14b6b8da86996$var$fitWidth = ()=>{
    const ratio = window.innerWidth / window.innerHeight;
    const fitRatio = $b4e14b6b8da86996$var$getFitRatio();
    return ratio <= fitRatio;
};
(()=>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const delay = urlParams.get("delay") === "true";
    const texts = [
        "\u0422\u0430\u0439\u043D\u0445\u0430\u0440\u0442",
        "Theinhardt",
        "\u03A4\u03B1\u03B9\u03BD\u03C7\u03B1\u03C1\u03C4",
        "\u041A\u0438\u0440\u0438\u043B\u043B\u0438\u0446\u0430",
        "Latin",
        "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03B1",
        "\u0412\u043E\u043B\u043E\u0441\u044F\u043D\u043E\u0435",
        "Hairline",
        "\u0399\u03C3\u03C7\u03BD\u03B1",
        "\u0421\u0432\u0435\u0440\u0445\u0442\u043E\u043D\u043A\u043E\u0435",
        "Ultralight",
        "\u03A5\u03C0\u03B5\u03C1\u03BB\u03B5\u03C5\u03BA\u03B1",
        "\u0422\u043E\u043D\u043A\u043E\u0435",
        "Thin",
        "\u039B\u03B5\u03C0\u03C4\u03B1",
        "\u0421\u0432\u0435\u0442\u043B\u043E\u0435",
        "Light",
        "\u039B\u03B5\u03C5\u03BA\u03B1",
        "\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E\u0435",
        "Regular",
        "\u039A\u03B1\u03BD\u03BF\u03BD\u03B9\u03BA\u03B1",
        "\u041F\u043E\u043B\u0443\u0436\u0438\u0440\u043D\u043E\u0435",
        "Medium",
        "\u039C\u03B5\u03C3\u03B1\u03B9\u03B1",
        "\u0416\u0438\u0440\u043D\u043E\u0435",
        "Bold",
        "\u039C\u03B1\u03C5\u03C1\u03B1",
        "\u0421\u0432\u0435\u0440\u0445\u0436\u0438\u0440\u043D\u043E\u0435",
        "Heavy",
        "\u0392\u03B1\u03C1\u03B5\u03B1",
        "\u0423\u043B\u044C\u0442\u0440\u0430\u0436\u0438\u0440\u043D\u043E\u0435",
        "Black",
        "\u039C\u03B1\u03C5\u03C1\u03B1"
    ];
    const textsMobile = [
        "\u0422\u0430\u0439\u043D\u0445\u0430\u0440\u0442",
        "Theinhardt",
        "\u03A4\u03B1\u03B9\u03BD\u03C7\u03B1\u03C1\u03C4",
        "\u041A\u0438\u0440\u0438\u043B\u043B\u0438\u0446\u0430",
        "Latin",
        "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03B1",
        "\u0422\u0430\u0439\u043D\u0445\u0430\u0440\u0442",
        "Theinhardt",
        "\u03A4\u03B1\u03B9\u03BD\u03C7\u03B1\u03C1\u03C4",
        "\u0422\u0430\u0439\u043D\u0445\u0430\u0440\u0442",
        "Theinhardt",
        "\u03A4\u03B1\u03B9\u03BD\u03C7\u03B1\u03C1\u03C4",
        "\u0422\u0430\u0439\u043D\u0445\u0430\u0440\u0442",
        "Theinhardt",
        "\u03A4\u03B1\u03B9\u03BD\u03C7\u03B1\u03C1\u03C4",
        "\u0422\u0430\u0439\u043D\u0445\u0430\u0440\u0442",
        "Theinhardt",
        "\u03A4\u03B1\u03B9\u03BD\u03C7\u03B1\u03C1\u03C4",
        "\u0422\u0430\u0439\u043D\u0445\u0430\u0440\u0442",
        "Theinhardt",
        "\u03A4\u03B1\u03B9\u03BD\u03C7\u03B1\u03C1\u03C4",
        "\u0422\u0430\u0439\u043D\u0445\u0430\u0440\u0442",
        "Theinhardt",
        "\u03A4\u03B1\u03B9\u03BD\u03C7\u03B1\u03C1\u03C4",
        "\u0422\u0430\u0439\u043D\u0445\u0430\u0440\u0442",
        "Theinhardt",
        "\u03A4\u03B1\u03B9\u03BD\u03C7\u03B1\u03C1\u03C4",
        "\u0422\u0430\u0439\u043D\u0445\u0430\u0440\u0442",
        "Theinhardt",
        "\u03A4\u03B1\u03B9\u03BD\u03C7\u03B1\u03C1\u03C4",
        "\u0422\u0430\u0439\u043D\u0445\u0430\u0440\u0442",
        "Theinhardt",
        "\u03A4\u03B1\u03B9\u03BD\u03C7\u03B1\u03C1\u03C4"
    ];
    const lines = Array.from(document.querySelectorAll(".line"));
    const writers = lines.map((line)=>new (0, $1715526d97494fcc$export$d7a960146e1a269e)(line));
    let textIndex = 0;
    const setLine = (writer, reset = true)=>{
        const fontIndex = Math.floor(textIndex / 3);
        const font = (0, $d13e1ce204297f81$export$f45fbea8fe20ca8a)[fontIndex];
        const lineIndex = textIndex % 3;
        (0, $df5bef30413a053b$export$1860c7b6fa9bf376)(lines[lineIndex], {
            fontFamily: font.group,
            fontWeight: `${font.weight}`
        });
        const t = $b4e14b6b8da86996$var$isMobile() ? textsMobile : texts;
        writer.setText(t[textIndex]);
        if (reset) writer.reset();
        textIndex++;
        textIndex %= texts.length;
    };
    writers.forEach((writer)=>{
        setLine(writer, false);
    });
    const steps = writers.map((writer)=>({
            duration: 1000,
            onStart () {
                setLine(writer);
            },
            handler (progress) {
                writer.render(progress);
            }
        }));
    const timeline = new (0, $37a01bc1518e38b9$exports.Timeline)(steps);
    const animator = new (0, $37a01bc1518e38b9$exports.Animator)([
        timeline
    ]);
    if (delay) {
        animator.stop();
        animator.startTime = 0;
        animator.computeFrameAt(0);
        window.addEventListener("message", ({ data: data })=>{
            const { action: action } = data;
            if (action === "start") animator.start();
            else if (action === "stop") animator.stop();
            else if (action === "reset") {
                animator.startTime = 0;
                animator.computeFrameAt(0);
                textIndex = 0;
                animator.startTime = Date.now();
                writers.forEach((writer)=>{
                    setLine(writer, false);
                });
            }
        }, false);
    } else animator.start();
    const updateFitMode = ()=>{
        const lines = document.querySelector(".lines");
        if ($b4e14b6b8da86996$var$fitWidth()) lines?.classList.add("fit-width");
        else lines?.classList.remove("fit-width");
        if ($b4e14b6b8da86996$var$isMobile()) lines?.classList.add("is-mobile");
        else lines?.classList.remove("is-mobile");
    };
    updateFitMode();
    window.addEventListener("resize", updateFitMode);
// document.addEventListener("visibilitychange", () => {
//   if (document.hidden) {
//     animator.stop();
//   } else {
//     textIndex = 0;
//     animator.startTime = Date.now();
//     writers.forEach((writer) => {
//       setLine(writer, false);
//     });
//     animator.start();
//   }
// });
})();


//# sourceMappingURL=path0.0a458c0e.js.map
